"use client";

import { useEffect } from "react";

/** Registers the app worker for installability, offline app-shell support, and push. */
export default function ServiceWorkerRegistration() {
	useEffect(() => {
		if (!("serviceWorker" in navigator)) return;

		// Turbopack development chunks are replaced in place. A service worker may
		// otherwise serve an old module factory after a refresh, so never keep one
		// registered while developing locally or on a development deployment.
		if (process.env.NODE_ENV !== "production") {
			void navigator.serviceWorker.getRegistrations().then((registrations) =>
				Promise.all(registrations.map((registration) => registration.unregister()))
			);
			return;
		}

		navigator.serviceWorker.register("/sw.js").catch((error) => {
			console.warn("Unable to register Jobstacky service worker:", error);
		});
	}, []);

	return null;
}
